import { openBlock, createElementBlock, createElementVNode, createStaticVNode, defineComponent, computed, createBlock, resolveDynamicComponent, mergeProps } from 'vue';

const _hoisted_1$1T = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1T = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 3a3 3 0 110 6 3 3 0 010-6zm0 13.987a7 7 0 005.62-2.827 1 1 0 00.07-1.01l-.23-.47A3 3 0 0014.77 13H9.23a3 3 0 00-2.71 1.72l-.21.44a1 1 0 00.07 1A7 7 0 0012 18.987z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1T = [
  _hoisted_2$1T
];

function render$1U(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1T, _hoisted_3$1T))
}

const _hoisted_1$1S = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1S = /*#__PURE__*/createElementVNode("path", {
  d: "M19 11.5v1a.5.5 0 01-.5.5H13v5.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H5.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11h5.5a.5.5 0 01.5.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1S = [
  _hoisted_2$1S
];

function render$1T(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1S, _hoisted_3$1S))
}

const _hoisted_1$1R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1R = /*#__PURE__*/createElementVNode("path", {
  d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm13.5 1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H13V8.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V11H8.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H11v2.5a.5.5 0 00.5.5h1a.5.5 0 00.5-.5V13h2.5z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1R = [
  _hoisted_2$1R
];

function render$1S(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1R, _hoisted_3$1R))
}

const _hoisted_1$1Q = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1Q = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-9h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H13v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V13H8.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H11V8.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V11z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1Q = [
  _hoisted_2$1Q
];

function render$1R(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1Q, _hoisted_3$1Q))
}

const _hoisted_1$1P = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1P = /*#__PURE__*/createElementVNode("path", {
  d: "M22.15 5.83l.7.71a.5.5 0 010 .71l-10.6 10.6a.5.5 0 01-.71 0l-5.39-5.39a.5.5 0 010-.71l.7-.7a.5.5 0 01.71 0l1.84 1.88 7-7.05a.51.51 0 01.71 0l.7.71a.5.5 0 010 .71l-7 7 1.08 1.08 9.55-9.55a.51.51 0 01.71 0zM8.31 16.79l-5.75-5.74a.5.5 0 00-.71 0l-.7.7a.5.5 0 000 .71l5.39 5.39a.5.5 0 00.71 0l1.06-1.06z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1P = [
  _hoisted_2$1P
];

function render$1Q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1P, _hoisted_3$1P))
}

const _hoisted_1$1O = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1O = /*#__PURE__*/createElementVNode("path", {
  d: "M22 11.5v1a.5.5 0 01-.5.5H5.33l4.45 4.44a.5.5 0 010 .71l-.71.7a.5.5 0 01-.71 0l-6.14-6.13a.75.75 0 01-.22-.53v-.38a.77.77 0 01.22-.53l6.14-6.13a.5.5 0 01.71 0l.71.71a.49.49 0 010 .7L5.33 11H21.5a.5.5 0 01.5.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1O = [
  _hoisted_2$1O
];

function render$1P(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1O, _hoisted_3$1O))
}

const _hoisted_1$1N = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1N = /*#__PURE__*/createElementVNode("path", { d: "M16 16.003v1a.5.5 0 01-.5.5H5.995v2a.5.5 0 01-.85.35l-3.001-3a.51.51 0 010-.71l3-3a.5.5 0 01.851.36v2H15.5a.5.5 0 01.5.5zM8 7.003v1a.5.5 0 00.5.5h9.505v2a.5.5 0 00.85.35l3.001-3a.51.51 0 000-.71l-3-3a.5.5 0 00-.851.36v2H8.5a.5.5 0 00-.5.5z" }, null, -1 /* HOISTED */);
const _hoisted_3$1N = [
  _hoisted_2$1N
];

function render$1O(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1N, _hoisted_3$1N))
}

const _hoisted_1$1M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1M = /*#__PURE__*/createElementVNode("path", {
  d: "M1.997 12.493v-1a.5.5 0 01.5-.5h15.505v-2a.5.5 0 01.85-.35l3 3a.51.51 0 010 .71l-3 3a.5.5 0 01-.85-.36v-2H2.497a.5.5 0 01-.5-.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1M = [
  _hoisted_2$1M
];

function render$1N(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1M, _hoisted_3$1M))
}

const _hoisted_1$1L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1L = /*#__PURE__*/createElementVNode("path", {
  d: "M18 9.5V17a6 6 0 01-12 0V5.5a4.5 4.5 0 019 0V16a3 3 0 11-6 0V9.5a.5.5 0 01.5-.5h.75a.5.5 0 01.5.5V16a1.25 1.25 0 102.5 0V5.5a2.75 2.75 0 10-5.5 0V17a4.25 4.25 0 008.5 0V9.5a.5.5 0 01.5-.5h.75a.5.5 0 01.5.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1L = [
  _hoisted_2$1L
];

function render$1M(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1L, _hoisted_3$1L))
}

const _hoisted_1$1K = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1K = /*#__PURE__*/createElementVNode("path", {
  d: "M13.304 20.24a6.06 6.06 0 01-8.548 0 5.996 5.996 0 010-8.48l8.498-8.44a4.557 4.557 0 016.416 0 4.468 4.468 0 010 6.36l-7.797 7.74a3.004 3.004 0 01-4.274 0 2.999 2.999 0 010-4.25l4.945-4.9a.5.5 0 01.71 0l.54.53a.5.5 0 010 .71l-4.944 4.9a1.26 1.26 0 00.08 1.7c.463.46 1.202.49 1.702.07l7.797-7.73a2.739 2.739 0 000-3.89 2.784 2.784 0 00-3.924 0L5.987 13a4.247 4.247 0 000 6 4.327 4.327 0 006.056 0l5.655-5.61a.51.51 0 01.721 0l.53.53a.48.48 0 010 .7l-5.645 5.62z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1K = [
  _hoisted_2$1K
];

function render$1L(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1K, _hoisted_3$1K))
}

const _hoisted_1$1J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1J = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm8 10a7.92 7.92 0 01-1.69 4.9L7.1 5.69A7.92 7.92 0 0112 4a8 8 0 018 8zM5.69 7.1A7.92 7.92 0 004 12a8 8 0 008 8 7.92 7.92 0 004.9-1.69L5.69 7.1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1J = [
  _hoisted_2$1J
];

function render$1K(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1J, _hoisted_3$1J))
}

const _hoisted_1$1I = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1I = /*#__PURE__*/createElementVNode("path", {
  d: "M18 4h1a2 2 0 012 2v13a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2h1V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h8V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4zM5 19h14V8H5v11z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1I = [
  _hoisted_2$1I
];

function render$1J(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1I, _hoisted_3$1I))
}

const _hoisted_1$1H = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1H = /*#__PURE__*/createElementVNode("path", {
  d: "M19 4h-1V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H8V2.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V4H5a2 2 0 00-2 2v13a2 2 0 002 2h14a2 2 0 002-2V6a2 2 0 00-2-2zm0 15H5V8h14v11zm-6.5-7h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm4 0a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM9 11.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm2.5 4.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zM9 15.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1H = [
  _hoisted_2$1H
];

function render$1I(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1H, _hoisted_3$1H))
}

const _hoisted_1$1G = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1G = /*#__PURE__*/createElementVNode("path", {
  d: "M13 4.5v-1a.51.51 0 01.15-.37.53.53 0 01.4-.13A8 8 0 0121 10.45a.53.53 0 01-.13.38.51.51 0 01-.37.15h-1a.5.5 0 01-.5-.46A6 6 0 0013.48 5a.5.5 0 01-.48-.5zm.17 2.64a.5.5 0 00-.17.38v1a.49.49 0 00.4.49 2 2 0 011.6 1.57.49.49 0 00.49.4h1a.5.5 0 00.5-.57A4.05 4.05 0 0013.59 7a.52.52 0 00-.4.14h-.02zm5.92 13.27a2 2 0 01-1.42.59H17a10.07 10.07 0 01-4.78-1.23l-.45-.25a18 18 0 01-7.33-7.33l-.25-.45A10.07 10.07 0 013 7v-.67a2 2 0 01.59-1.42l1.69-1.69a.75.75 0 011.18.15l2.25 3.86a1 1 0 01-.16 1.21l-1.89 1.89a.5.5 0 00-.09.59l.35.66a13.53 13.53 0 005.5 5.49l.66.36a.5.5 0 00.59-.09l1.89-1.89a1 1 0 011.21-.16l3.86 2.25a.75.75 0 01.15 1.18l-1.69 1.69z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1G = [
  _hoisted_2$1G
];

function render$1H(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1G, _hoisted_3$1G))
}

const _hoisted_1$1F = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1F = /*#__PURE__*/createElementVNode("path", {
  d: "M8.138 11.06A.518.518 0 018 10.705c0-.133.05-.261.138-.355l.187-.2A.442.442 0 018.66 10h6.68a.443.443 0 01.335.15l.187.2a.519.519 0 01.138.355c0 .133-.05.26-.138.355l-3.536 3.788A.434.434 0 0112 15a.434.434 0 01-.326-.152L8.138 11.06z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1F = [
  _hoisted_2$1F
];

function render$1G(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1F, _hoisted_3$1F))
}

const _hoisted_1$1E = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1E = /*#__PURE__*/createElementVNode("path", {
  d: "M16.14 12.94a.5.5 0 010 .71l-.2.2a.49.49 0 01-.36.15H8.42a.49.49 0 01-.36-.15l-.2-.2a.5.5 0 010-.71l3.79-3.79a.48.48 0 01.7 0l3.79 3.79z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1E = [
  _hoisted_2$1E
];

function render$1F(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1E, _hoisted_3$1E))
}

const _hoisted_1$1D = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1D = /*#__PURE__*/createElementVNode("path", {
  d: "M20.87 10.84a.51.51 0 00.13-.37A8 8 0 0013.53 3a.5.5 0 00-.37.15.52.52 0 00-.16.37V11h7.5a.52.52 0 00.37-.16zM11 13h7.48a.5.5 0 01.5.52 8 8 0 11-8.5-8.5.5.5 0 01.52.5V13z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1D = [
  _hoisted_2$1D
];

function render$1E(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1D, _hoisted_3$1D))
}

const _hoisted_1$1C = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1C = /*#__PURE__*/createElementVNode("path", {
  d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm8.73 3.35l5.62-5.62a.5.5 0 000-.69l-.53-.53a.5.5 0 00-.7 0l-4.74 4.74-1.5-1.49a.48.48 0 00-.7 0l-.53.53a.5.5 0 000 .71l2.38 2.35a.48.48 0 00.7 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1C = [
  _hoisted_2$1C
];

function render$1D(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1C, _hoisted_3$1C))
}

const _hoisted_1$1B = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1B = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm3.12-11.51a.5.5 0 01.7 0l.5.53a.5.5 0 010 .71l-5.62 5.62a.48.48 0 01-.7 0l-2.35-2.37a.5.5 0 010-.71l.53-.53a.48.48 0 01.7 0l1.5 1.49 4.74-4.74z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1B = [
  _hoisted_2$1B
];

function render$1C(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1B, _hoisted_3$1B))
}

const _hoisted_1$1A = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1A = /*#__PURE__*/createElementVNode("path", {
  d: "M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2V5a2 2 0 00-2-2zm0 16H5V5h14v14zm-8.65-3.498a.48.48 0 01-.35-.152l-2.38-2.37a.5.5 0 010-.71l.53-.53a.48.48 0 01.7 0l1.5 1.49 4.74-4.74a.5.5 0 01.7 0l.53.53a.5.5 0 010 .71l-5.62 5.62a.48.48 0 01-.35.152z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1A = [
  _hoisted_2$1A
];

function render$1B(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1A, _hoisted_3$1A))
}

const _hoisted_1$1z = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1z = /*#__PURE__*/createElementVNode("path", {
  d: "M12.72 15.78a.75.75 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-5.13-5.14a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L12 13.67l4.44-4.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-5.13 5.14z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1z = [
  _hoisted_2$1z
];

function render$1A(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1z, _hoisted_3$1z))
}

const _hoisted_1$1y = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1y = /*#__PURE__*/createElementVNode("path", {
  d: "M15.78 11.28c.14.14.22.331.22.53v.38a.77.77 0 01-.22.53l-5.14 5.13a.5.5 0 01-.71 0l-.71-.71a.49.49 0 010-.7L13.67 12 9.22 7.56a.5.5 0 010-.71l.71-.7a.5.5 0 01.71 0l5.14 5.13z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1y = [
  _hoisted_2$1y
];

function render$1z(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1y, _hoisted_3$1y))
}

const _hoisted_1$1x = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1x = /*#__PURE__*/createElementVNode("path", {
  d: "M11.28 8.22a.75.75 0 01.53-.22h.38a.77.77 0 01.53.22l5.13 5.14a.5.5 0 010 .71l-.71.71a.49.49 0 01-.7 0L12 10.33l-4.44 4.45a.5.5 0 01-.71 0l-.7-.71a.5.5 0 010-.71l5.13-5.14z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1x = [
  _hoisted_2$1x
];

function render$1y(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1x, _hoisted_3$1x))
}

const _hoisted_1$1w = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1w = /*#__PURE__*/createElementVNode("path", {
  d: "M7.113 6.176a.6.6 0 01.848 0L12 10.214l4.038-4.038a.6.6 0 01.849 0l.937.937a.6.6 0 010 .848L13.785 12l4.04 4.04a.6.6 0 010 .848l-.937.937a.6.6 0 01-.849 0L12 13.784l-4.038 4.04a.6.6 0 01-.849 0l-.937-.937a.6.6 0 010-.848l4.04-4.04-4.039-4.038a.6.6 0 010-.849l.937-.936z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1w = [
  _hoisted_2$1w
];

function render$1x(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1w, _hoisted_3$1w))
}

const _hoisted_1$1v = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1v = /*#__PURE__*/createElementVNode("path", {
  d: "M4 12a8 8 0 1116 0 8 8 0 01-16 0zm11 2.045c0-.122-.05-.24-.14-.324L13.148 12l1.712-1.721a.445.445 0 000-.648l-.49-.49a.444.444 0 00-.649 0L12 10.851 10.279 9.14a.444.444 0 00-.648 0l-.49.49a.444.444 0 000 .649L10.851 12 9.14 13.721a.444.444 0 000 .648l.49.49a.444.444 0 00.649 0L12 13.149l1.721 1.712a.444.444 0 00.648 0l.49-.49a.445.445 0 00.141-.325z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1v = [
  _hoisted_2$1v
];

function render$1w(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1v, _hoisted_3$1v))
}

const _hoisted_1$1u = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1u = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm2.56-11.09l.53.53a.48.48 0 010 .7L13.24 12l1.85 1.86a.48.48 0 010 .7l-.53.53a.48.48 0 01-.7 0L12 13.24l-1.86 1.85a.48.48 0 01-.7 0l-.53-.53a.48.48 0 010-.7L10.76 12l-1.85-1.86a.48.48 0 010-.7l.53-.53a.48.48 0 01.7 0L12 10.76l1.86-1.85a.48.48 0 01.7 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1u = [
  _hoisted_2$1u
];

function render$1v(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1u, _hoisted_3$1u))
}

const _hoisted_1$1t = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1t = /*#__PURE__*/createElementVNode("path", {
  d: "M14.36 4.028l.97.369h-.04a.499.499 0 01.3.628l-5.31 14.648a.51.51 0 01-.64.3l-.94-.34a.499.499 0 01-.3-.638l5.31-14.668a.52.52 0 01.65-.3zM4.33 12.01l3.44-3.432a.488.488 0 000-.699l-.71-.708a.5.5 0 00-.71 0l-4.13 4.12a.767.767 0 00-.22.53v.379c0 .198.08.388.22.529l4.14 4.12a.5.5 0 00.71 0l.71-.698a.498.498 0 000-.708L4.33 12.01zM22 12.2a.767.767 0 01-.22.529l-4.14 4.12a.5.5 0 01-.71 0l-.71-.708a.488.488 0 010-.698l3.45-3.433-3.45-3.432a.498.498 0 010-.709l.71-.698a.5.5 0 01.71 0l4.14 4.12c.14.141.22.331.22.53v.379z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1t = [
  _hoisted_2$1t
];

function render$1u(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1t, _hoisted_3$1t))
}

const _hoisted_1$1s = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1s = /*#__PURE__*/createElementVNode("path", {
  d: "M20 14a8 8 0 11-16 0c0-3.81 2.86-7.36 5.5-10l1.82-1.82a.75.75 0 01.53-.18h.3c.199 0 .39.08.53.22L14.5 4c2.64 2.64 5.5 6.19 5.5 10z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1s = [
  _hoisted_2$1s
];

function render$1t(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1s, _hoisted_3$1s))
}

const _hoisted_1$1r = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1r = /*#__PURE__*/createElementVNode("path", {
  d: "M18 16V4a2 2 0 00-2-2H4a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2zM4 4h12v12H4V4zm16 14V6a2 2 0 012 2v10a4 4 0 01-4 4H8a2 2 0 01-2-2h12a2 2 0 002-2z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1r = [
  _hoisted_2$1r
];

function render$1s(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1r, _hoisted_3$1r))
}

const _hoisted_1$1q = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1q = /*#__PURE__*/createElementVNode("path", {
  d: "M17 4a5 5 0 015 5 4.94 4.94 0 01-1 3v6a2 2 0 01-2 2H4a2 2 0 01-2-2V7a2 2 0 012-2h10a4.94 4.94 0 013-1zm-.38 2a.5.5 0 00-.5.5v1.62H14.5a.5.5 0 00-.5.5v.76a.5.5 0 00.5.5h1.62v1.62a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5V9.88h1.62a.5.5 0 00.5-.5v-.76a.5.5 0 00-.5-.5h-1.62V6.5a.5.5 0 00-.5-.5h-.76zM4 7h8.42A4.94 4.94 0 0012 9c.003.336.036.67.1 1H4V7zm0 6v5h15v-4.42a4.93 4.93 0 01-5-.58H4z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1q = [
  _hoisted_2$1q
];

function render$1r(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1q, _hoisted_3$1q))
}

const _hoisted_1$1p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1p = /*#__PURE__*/createElementVNode("path", {
  d: "M20 5.5v-1a.5.5 0 00-.5-.5H15V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zM7.87 22a2 2 0 01-2-1.86L5 8h14l-.85 12.14a2 2 0 01-2 1.86H7.87z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1p = [
  _hoisted_2$1p
];

function render$1q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1p, _hoisted_3$1p))
}

const _hoisted_1$1o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1o = /*#__PURE__*/createElementVNode("path", {
  d: "M20 5.5v-1a.5.5 0 00-.5-.5H15V3a1 1 0 00-1-1h-4a1 1 0 00-1 1v1H4.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-4.662 14.64a1 1 0 00.998-.94L17 8h2l-.85 12.14a2 2 0 01-2 1.86H7.87a2 2 0 01-2-1.86L5 8h2l.664 11.2a1 1 0 00.998.94h6.676z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1o = [
  _hoisted_2$1o
];

function render$1p(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1o, _hoisted_3$1o))
}

const _hoisted_1$1n = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1n = /*#__PURE__*/createElementVNode("path", {
  d: "M21.74 8.16l-4.15-4.51A2 2 0 0016.12 3H7.88a2 2 0 00-1.47.65L2.26 8.16a1 1 0 00-.26.68v.3a1 1 0 00.23.64l9 10.86a1 1 0 001.54 0l9-10.86a1 1 0 00.23-.64v-.3a1 1 0 00-.26-.68zm-10.56 9.31l-6.65-8A.253.253 0 114.72 9h3.55a1 1 0 011 .69l2.39 7.55a.266.266 0 11-.48.23zM13.07 9h6.17a.25.25 0 00.18-.42L16.31 5.2a.25.25 0 00-.37 0l-3.06 3.38a.25.25 0 00.19.42z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1n = [
  _hoisted_2$1n
];

function render$1o(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1n, _hoisted_3$1n))
}

const _hoisted_1$1m = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1m = /*#__PURE__*/createElementVNode("path", {
  d: "M14.33 3.307L12 2 9.67 3.307 7 3.34 5.636 5.636 3.34 7l-.033 2.67L2 12l1.307 2.33L3.34 17l2.296 1.364L7 20.66l2.67.033L12 22l2.33-1.307L17 20.66l1.364-2.296L20.66 17l.033-2.67L22 12l-1.307-2.33L20.66 7l-2.296-1.364L17 3.34l-2.67-.033zM12 9.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-.608-6.429l.758.758-7.071 7.07-.758-.757 7.071-7.07z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1m = [
  _hoisted_2$1m
];

function render$1n(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1m, _hoisted_3$1m))
}

const _hoisted_1$1l = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1l = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2l.482.27 1.847 1.037 2.118.026.553.007.282.475 1.082 1.821 1.82 1.082.476.282.007.553.026 2.118 1.037 1.847L22 12l-.27.482-1.037 1.847-.026 2.118-.007.553-.475.282-1.821 1.082-1.082 1.82-.282.476-.553.007-2.118.026-1.847 1.037L12 22l-.482-.27-1.847-1.037-2.118-.026L7 20.66l-.282-.475-1.082-1.821-1.82-1.082L3.34 17l-.007-.553-.026-2.118-1.037-1.847L2 12l.27-.482L3.307 9.67l.026-2.118L3.34 7l.475-.282 1.821-1.082 1.082-1.82L7 3.34l.553-.007 2.118-.026 1.847-1.037L12 2zm0 2.26l-1.584.889-.219.122-.25.004-1.817.022-.927 1.561-.129.216-.216.129-1.561.927-.022 1.816-.004.251-.122.219L4.26 12l.889 1.584.122.219.004.25.022 1.817 1.561.928.216.128.129.216.927 1.561 1.816.023.251.003.219.122L12 19.74l1.584-.889.219-.122.25-.003 1.817-.023.928-1.561.128-.216.216-.128 1.561-.928.023-1.816.003-.251.122-.219L19.74 12l-.889-1.584-.122-.219-.003-.25-.023-1.817-1.561-.927-.216-.129-.128-.216-.928-1.561-1.816-.022-.251-.004-.219-.122L12 4.26zm0 5.24a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm6.25 5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-1.25 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-.608-6.429l.758.758-7.071 7.07-.758-.757 7.071-7.07z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1l = [
  _hoisted_2$1l
];

function render$1m(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1l, _hoisted_3$1l))
}

const _hoisted_1$1k = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1k = /*#__PURE__*/createElementVNode("path", {
  d: "M19.793 6.965a.77.77 0 01-.022 1.075l-9.815 9.607a1.224 1.224 0 01-1.714.006l-4.01-3.878a.77.77 0 01-.028-1.074l.684-.736a.735.735 0 011.053-.028l3.15 3.046 8.96-8.771a.735.735 0 011.054.022l.688.731z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1k = [
  _hoisted_2$1k
];

function render$1l(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1k, _hoisted_3$1k))
}

const _hoisted_1$1j = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1j = /*#__PURE__*/createElementVNode("path", {
  d: "M16.288 9.295a.5.5 0 00-.148-.355l-3.79-3.79a.48.48 0 00-.7 0L7.86 8.94a.5.5 0 000 .71l.2.2a.49.49 0 00.36.15h7.16a.49.49 0 00.36-.15l.2-.2a.5.5 0 00.148-.355zm-8.576 5.41a.5.5 0 00.148.355l3.79 3.79a.48.48 0 00.7 0l3.79-3.79a.5.5 0 000-.71l-.2-.2a.49.49 0 00-.36-.15H8.42a.49.49 0 00-.36.15l-.2.2a.5.5 0 00-.148.355z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1j = [
  _hoisted_2$1j
];

function render$1k(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1j, _hoisted_3$1j))
}

const _hoisted_1$1i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1i = /*#__PURE__*/createElementVNode("path", {
  d: "M12 17.002a.48.48 0 01-.35-.152l-5.79-5.79a.5.5 0 010-.71l.2-.2a.49.49 0 01.36-.15H9V4.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5V10h2.58a.49.49 0 01.36.15l.2.2a.5.5 0 010 .71l-5.79 5.79a.48.48 0 01-.35.151zm7 3.498v-1a.5.5 0 00-.5-.5h-13a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h13a.5.5 0 00.5-.5z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1i = [
  _hoisted_2$1i
];

function render$1j(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1i, _hoisted_3$1i))
}

const _hoisted_1$1h = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1h = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 01-1-15.93v.43a.5.5 0 01-.5.5.5.5 0 00-.5.5v1a.5.5 0 00.5.5h3a.48.48 0 01.5.48.51.51 0 00.5.52A1.5 1.5 0 0116 9.5V11h-1a1 1 0 01-1-1v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 01-.5-.5.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V9a1 1 0 01-1 1 1 1 0 00-1 1v1a1 1 0 001 1h1.59a1 1 0 01.7.29l.42.42a1 1 0 01.29.7V17a1 1 0 001 1h.5a.5.5 0 00.5-.5.5.5 0 01.5-.5 1.5 1.5 0 001.5-1.5v-2a.49.49 0 01.45-.5.52.52 0 00.55-.48V11h1a1 1 0 001-1V9h1.41a7.9 7.9 0 01.59 3 8 8 0 01-8 8z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$1h = [
  _hoisted_2$1h
];

function render$1i(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1h, _hoisted_3$1h))
}

const _hoisted_1$1g = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1g = /*#__PURE__*/createElementVNode("path", {
  d: "M19.902 3.44l.659.658c.28.28.439.66.439 1.058v.758c.005.404-.153.793-.44 1.078l-1.845 1.816a.499.499 0 01-.708 0l-2.804-2.844a.499.499 0 010-.698l1.806-1.827A1.497 1.497 0 0118.087 3h.758c.397 0 .777.158 1.057.44zm-3.082 7.245a.5.5 0 000-.699l-2.854-2.814a.499.499 0 00-.708 0l-8.052 8.053a1.995 1.995 0 00-.449.68l-1.716 4.33a.499.499 0 00.19.62.499.499 0 00.538.109l4.33-1.757c.255-.101.486-.254.679-.449l8.042-8.073z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1g = [
  _hoisted_2$1g
];

function render$1h(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1g, _hoisted_3$1g))
}

const _hoisted_1$1f = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1f = /*#__PURE__*/createElementVNode("path", {
  d: "M4 4h16a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm9.65 11.45L20 11V8.9l-7.35 5.15a1.14 1.14 0 01-1.3 0L4 8.9V11l6.35 4.45a2.88 2.88 0 003.3 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1f = [
  _hoisted_2$1f
];

function render$1g(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1f, _hoisted_3$1f))
}

const _hoisted_1$1e = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1e = /*#__PURE__*/createElementVNode("path", { d: "M17 10.6a.4.4 0 01-.4.4H7.4a.4.4 0 01-.4-.4V9.4c0-.22.18-.4.4-.4h9.2c.22 0 .4.18.4.4v1.2zM17 14.6a.4.4 0 01-.4.4H7.4a.4.4 0 01-.4-.4v-1.2c0-.22.18-.4.4-.4h9.2c.22 0 .4.18.4.4v1.2z" }, null, -1 /* HOISTED */);
const _hoisted_3$1e = [
  _hoisted_2$1e
];

function render$1f(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1e, _hoisted_3$1e))
}

const _hoisted_1$1d = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1d = /*#__PURE__*/createElementVNode("path", { d: "M9.471 9.197l-.007.005-.762.447a.402.402 0 00-.125.115l-.022.04a.403.403 0 000 .396l.022.04a.403.403 0 00.125.115l6.116 3.594c.19.112.433.047.542-.145l.588-1.036a.408.408 0 00-.148-.551l-3.769-2.215L15.8 7.787a.408.408 0 00.147-.55L15.36 6.2a.393.393 0 00-.542-.145L9.47 9.197zM8 17.6c0 .22.18.4.4.4h7.2a.4.4 0 00.4-.4v-1.2a.4.4 0 00-.4-.4H8.4a.4.4 0 00-.4.4v1.2z" }, null, -1 /* HOISTED */);
const _hoisted_3$1d = [
  _hoisted_2$1d
];

function render$1e(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1d, _hoisted_3$1d))
}

const _hoisted_1$1c = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1c = /*#__PURE__*/createElementVNode("path", { d: "M14.529 9.197l.007.005.762.447c.05.03.093.07.125.115l.022.04a.402.402 0 010 .396l-.022.04a.402.402 0 01-.125.115l-6.116 3.594a.393.393 0 01-.542-.145l-.587-1.036a.408.408 0 01.147-.551l3.769-2.215L8.2 7.787a.408.408 0 01-.147-.55L8.64 6.2a.393.393 0 01.542-.145l5.347 3.142zM16 17.6a.4.4 0 01-.4.4H8.4a.4.4 0 01-.4-.4v-1.2c0-.22.18-.4.4-.4h7.2c.22 0 .4.18.4.4v1.2z" }, null, -1 /* HOISTED */);
const _hoisted_3$1c = [
  _hoisted_2$1c
];

function render$1d(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1c, _hoisted_3$1c))
}

const _hoisted_1$1b = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1b = /*#__PURE__*/createElementVNode("path", { d: "M8.158 17.501a.3.3 0 01-.116-.417l6.544-10.931a.323.323 0 01.433-.112l.823.458a.3.3 0 01.115.417L9.415 17.847a.323.323 0 01-.433.112l-.823-.458zM12.118 15H16.5c.276 0 .5-.18.5-.4v-1.2c0-.22-.224-.4-.5-.4h-3.185l-1.197 2zM14.513 11H16.5c.276 0 .5-.18.5-.4V9.4c0-.22-.224-.4-.5-.4h-.79l-1.197 2z" }, null, -1 /* HOISTED */);
const _hoisted_3$1b = /*#__PURE__*/createElementVNode("path", { d: "M13.882 9l-1.197 2H7.5c-.276 0-.5-.18-.5-.4V9.4c0-.22.224-.4.5-.4h6.382zM11.487 13l-1.197 2H7.5c-.276 0-.5-.18-.5-.4v-1.2c0-.22.224-.4.5-.4h3.987z" }, null, -1 /* HOISTED */);
const _hoisted_4$7 = [
  _hoisted_2$1b,
  _hoisted_3$1b
];

function render$1c(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1b, _hoisted_4$7))
}

const _hoisted_1$1a = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$1a = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm1 13.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.47-3.5a.25.25 0 00.25-.22l.4-3.22a.5.5 0 00-.5-.56h-1.36a.5.5 0 00-.5.56l.4 3.22a.25.25 0 00.25.22h1.06z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1a = [
  _hoisted_2$1a
];

function render$1b(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1a, _hoisted_3$1a))
}

const _hoisted_1$19 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$19 = /*#__PURE__*/createElementVNode("path", {
  d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm2 0a8 8 0 1016 0 8 8 0 00-16 0zm7.5 2a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-.18-6h1.36a.5.5 0 01.5.56l-.4 3.22a.25.25 0 01-.25.22h-1.06a.25.25 0 01-.25-.22l-.4-3.22a.5.5 0 01.5-.56z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$19 = [
  _hoisted_2$19
];

function render$1a(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$19, _hoisted_3$19))
}

const _hoisted_1$18 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$18 = /*#__PURE__*/createElementVNode("path", { d: "M7.324 11.059c-.293-.328-.705-.496-1.227-.496-.614 0-1.117.21-1.511.63-.394.42-.586.95-.586 1.588 0 .64.192 1.169.586 1.589.394.42.897.63 1.51.63.523 0 .935-.168 1.228-.496v.378h1.693v-4.201H7.324v.378zm-1.41 2.286a.831.831 0 010-1.127.809.809 0 01.595-.226c.247 0 .44.075.586.226a.813.813 0 010 1.127c-.147.15-.34.226-.586.226a.809.809 0 01-.595-.226zM15 4h2v16h-2V4z" }, null, -1 /* HOISTED */);
const _hoisted_3$18 = /*#__PURE__*/createElementVNode("path", { d: "M14 4h4v1h-4V4zM14 19h4v1h-4v-1zM14 6H3a2 2 0 00-2 2v8a2 2 0 002 2h11v-2H3V8h11V6zM18 6v2h3v8h-3v2h3a2 2 0 002-2V8a2 2 0 00-2-2h-3z" }, null, -1 /* HOISTED */);
const _hoisted_4$6 = [
  _hoisted_2$18,
  _hoisted_3$18
];

function render$19(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$18, _hoisted_4$6))
}

const _hoisted_1$17 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$17 = /*#__PURE__*/createElementVNode("path", { d: "M3 6h18a2 2 0 012 2v8a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2zm18 10V8H3v8h18z" }, null, -1 /* HOISTED */);
const _hoisted_3$17 = /*#__PURE__*/createElementVNode("path", { d: "M7.324 11.059c-.293-.328-.705-.496-1.227-.496-.614 0-1.117.21-1.511.63-.394.42-.586.95-.586 1.588 0 .64.192 1.169.586 1.589.394.42.897.63 1.51.63.523 0 .935-.168 1.228-.496v.378h1.693v-4.201H7.324v.378zm-1.41 2.286a.831.831 0 010-1.127.809.809 0 01.595-.226c.247 0 .44.075.586.226a.813.813 0 010 1.127c-.147.15-.34.226-.586.226a.809.809 0 01-.595-.226zM12.903 10.563c-.521 0-.934.168-1.226.496V9H9.983v5.882h1.694v-.378c.293.328.705.496 1.226.496.614 0 1.117-.21 1.511-.63.394-.42.586-.95.586-1.588 0-.64-.192-1.169-.586-1.589-.394-.42-.897-.63-1.51-.63zm-1.007 2.781a.831.831 0 010-1.125.81.81 0 01.595-.227c.248 0 .44.075.586.226a.813.813 0 010 1.127c-.146.15-.338.226-.586.226a.81.81 0 01-.595-.226z" }, null, -1 /* HOISTED */);
const _hoisted_4$5 = [
  _hoisted_2$17,
  _hoisted_3$17
];

function render$18(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$17, _hoisted_4$5))
}

const _hoisted_1$16 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$16 = /*#__PURE__*/createElementVNode("path", {
  d: "M17 3v14a2 2 0 01-2 2H4a2 2 0 01-2-2V8.24a3 3 0 01.88-2.12l4.24-4.24A3 3 0 019.24 1H15a2 2 0 012 2zM9 9H4v8h11V3h-5v5a1 1 0 01-1 1zm3.5 3h-6a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h6a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zm4.5 9a2 2 0 002-2V5a2 2 0 012 2v12a4 4 0 01-4 4H8a2 2 0 01-2-2h11z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$16 = [
  _hoisted_2$16
];

function render$17(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$16, _hoisted_3$16))
}

const _hoisted_1$15 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$15 = /*#__PURE__*/createElementVNode("path", {
  d: "M10 14.83a2 2 0 00-.59-1.42L3.59 7.59A2 2 0 013 6.17V5a1 1 0 011-1h16a1 1 0 011 1v1.17a2 2 0 01-.59 1.42l-5.82 5.82a2 2 0 00-.59 1.42v3.67a2 2 0 01-.8 1.6l-2.4 1.8a.5.5 0 01-.8-.4v-6.67z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$15 = [
  _hoisted_2$15
];

function render$16(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$15, _hoisted_3$15))
}

const _hoisted_1$14 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$14 = /*#__PURE__*/createElementVNode("path", {
  d: "M20 6.5v9a.5.5 0 01-.5.5H14a2 2 0 01-2-2H6v7.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h6a2 2 0 012 2h5.5a.5.5 0 01.5.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$14 = [
  _hoisted_2$14
];

function render$15(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$14, _hoisted_3$14))
}

const _hoisted_1$13 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$13 = /*#__PURE__*/createElementVNode("path", {
  d: "M11 4a2 2 0 012 2h6.5a.5.5 0 01.5.5v9a.5.5 0 01-.5.5H13a2 2 0 01-2-2H6v7.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-19a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h5zM6 6v6h6.5a.5.5 0 01.5.5V14h5V8h-6.5a.5.5 0 01-.5-.5V6H6z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$13 = [
  _hoisted_2$13
];

function render$14(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$13, _hoisted_3$13))
}

const _hoisted_1$12 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$12 = /*#__PURE__*/createElementVNode("path", {
  d: "M18.09 10.22l-7 11.42a.76.76 0 01-.64.36h-.2a.51.51 0 01-.37-.16.49.49 0 01-.13-.38l.56-6.46H6.74a.76.76 0 01-.65-.38l-.19-.33a.49.49 0 010-.51l7-11.42a.76.76 0 01.66-.36h.2a.51.51 0 01.37.16.49.49 0 01.13.38L13.69 9h3.57a.76.76 0 01.65.38l.19.33a.49.49 0 01-.01.51z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$12 = [
  _hoisted_2$12
];

function render$13(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$12, _hoisted_3$12))
}

const _hoisted_1$11 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$11 = /*#__PURE__*/createElementVNode("path", {
  d: "M4 4h7.59a1 1 0 01.7.29l1.42 1.42a1 1 0 00.7.29H20a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2zm8.3 3.12L11.17 6H4v12h16V8h-5.59a3 3 0 01-2.11-.88z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$11 = [
  _hoisted_2$11
];

function render$12(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$11, _hoisted_3$11))
}

const _hoisted_1$10 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$10 = /*#__PURE__*/createElementVNode("path", {
  d: "M3 6a2 2 0 114 0 2 2 0 01-4 0zm17.5 1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h11zm-11 4h11a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-11a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5zm11 6h-11a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h11a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5zM5 10a2 2 0 100 4 2 2 0 000-4zm-2 8a2 2 0 114 0 2 2 0 01-4 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$10 = [
  _hoisted_2$10
];

function render$11(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$10, _hoisted_3$10))
}

const _hoisted_1$$ = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$$ = /*#__PURE__*/createElementVNode("path", { d: "M10.847 8.616l-1.198 5.052c-.56 2.384-1.106 4.111-1.639 5.183-.532 1.072-1.155 1.864-1.868 2.378-.714.514-1.531.771-2.453.771-.58 0-1.006-.119-1.28-.355-.272-.237-.409-.516-.409-.837 0-.299.113-.557.338-.776.225-.219.522-.328.89-.328.308 0 .543.084.707.251.164.168.246.38.246.635 0 .233-.051.406-.154.52-.102.112-.153.187-.153.223l.05.077c.042.037.09.054.144.054.205 0 .379-.069.522-.207.362-.343.632-.759.809-1.247.123-.335.358-1.221.706-2.657l2.09-8.737H6.77l.338-1.28c.512.008.884-.062 1.116-.208.232-.146.478-.474.737-.984.75-1.48 1.543-2.54 2.375-3.182C12.17 2.321 13.098 2 14.122 2c.655 0 1.132.135 1.428.405.298.27.446.62.446 1.05 0 .379-.1.68-.297.902a.947.947 0 01-.737.333.904.904 0 01-.676-.273.906.906 0 01-.266-.656c0-.182.056-.376.168-.58.113-.203.17-.342.17-.415a.264.264 0 00-.078-.197.271.271 0 00-.2-.076c-.402 0-.815.266-1.238.798-.696.853-1.256 2.202-1.68 4.046h1.485l-.358 1.28h-1.442v-.001z" }, null, -1 /* HOISTED */);
const _hoisted_3$$ = /*#__PURE__*/createElementVNode("path", { d: "M13.294 7.686l3.573-.656a11.386 11.386 0 011.372 3.586c.669-1.057 1.174-1.796 1.515-2.22.458-.568.835-.938 1.132-1.11.297-.17.612-.256.947-.256.375 0 .663.11.865.328.201.219.302.514.302.886 0 .35-.101.636-.302.858a.973.973 0 01-.752.334c-.219 0-.47-.042-.753-.126-.283-.084-.48-.126-.589-.126-.286 0-.56.11-.819.328-.355.3-.792.937-1.31 1.914.58 2.187 1.044 3.521 1.392 4.002.205.285.413.427.624.427.178 0 .331-.048.461-.142.198-.153.502-.536.911-1.148l.369.23c-.6 1.034-1.188 1.763-1.761 2.186-.437.328-.867.492-1.29.492-.437 0-.8-.104-1.09-.312-.29-.208-.548-.547-.774-1.017-.225-.47-.49-1.223-.798-2.258-.799 1.086-1.425 1.88-1.879 2.378-.454.5-.83.826-1.131.979-.3.153-.621.23-.963.23-.354 0-.636-.11-.845-.328-.208-.219-.312-.503-.312-.853 0-.372.113-.678.338-.919.225-.24.512-.36.86-.36.184 0 .393.058.625.175.341.175.587.262.737.262.197 0 .375-.044.532-.131.205-.11.464-.347.778-.711.191-.226.543-.707 1.055-1.443-.655-2.596-1.167-4.148-1.536-4.659-.232-.328-.526-.491-.88-.491-.185 0-.41.029-.677.087l.073-.416z" }, null, -1 /* HOISTED */);
const _hoisted_4$4 = [
  _hoisted_2$$,
  _hoisted_3$$
];

function render$10(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$$, _hoisted_4$4))
}

const _hoisted_1$_ = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$_ = /*#__PURE__*/createElementVNode("path", {
  d: "M11 11a3 3 0 10-.9-5.86 5 5 0 010 5.72 3 3 0 00.9.14zm-5 0a3 3 0 100-6 3 3 0 000 6zm5.89 5.55A1 1 0 0111 18H1a1 1 0 01-.89-1.45l1-1.9A3 3 0 013.74 13h4.52a3 3 0 012.68 1.65l.95 1.9zM21 10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H21v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V12h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H19V7.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10zm-7.74 3a3 3 0 012.68 1.65l.95 1.9A1 1 0 0116 18h-2.18a3 3 0 00-.13-2.35l-.95-1.89a4.891 4.891 0 00-.48-.76h1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$_ = [
  _hoisted_2$_
];

function render$$(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$_, _hoisted_3$_))
}

const _hoisted_1$Z = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Z = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm3.237-10.576A2.424 2.424 0 0012.812 7H11.13a2.424 2.424 0 00-2.424 2.424v.421c0 .233.188.421.42.421h.64a.42.42 0 00.421-.42v-.422a.943.943 0 01.943-.942h1.683c.521 0 .943.422.943.942v.472a.951.951 0 01-.64.9l-.8.261a1.582 1.582 0 00-1.085 1.499v.656c0 .233.188.421.42.421h.64a.42.42 0 00.421-.42v-.657a.11.11 0 01.101-.101l.8-.261a2.433 2.433 0 001.684-2.298l-.06-.472zm-2.845 5.893h-.842a.42.42 0 00-.421.42v.842c0 .233.188.421.42.421h.843a.42.42 0 00.42-.42v-.843a.42.42 0 00-.42-.42z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$Z = [
  _hoisted_2$Z
];

function render$_(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Z, _hoisted_3$Z))
}

const _hoisted_1$Y = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Y = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm1 13.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v3zm-.5-5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$Y = [
  _hoisted_2$Y
];

function render$Z(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Y, _hoisted_3$Y))
}

const _hoisted_1$X = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$X = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm.5-12.402a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1zm0 3c.276 0 .5.048.5.448v4.117c.266.074.53.138.76.189.14.03.241.153.241.296v.454a.3.3 0 01-.3.3H10.3a.3.3 0 01-.3-.3v-.454c0-.143.1-.265.24-.296.23-.05.495-.115.76-.189v-3.326c-.265-.074-.53-.138-.76-.189a.305.305 0 01-.24-.296v-.454a.3.3 0 01.3-.3h2.2z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$X = [
  _hoisted_2$X
];

function render$Y(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$X, _hoisted_3$X))
}

const _hoisted_1$W = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$W = /*#__PURE__*/createElementVNode("path", {
  d: "M19 8H5v8h14V8zM5 6a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2H5z",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$W = /*#__PURE__*/createElementVNode("path", { d: "M8.44 14c.906 0 1.492-.49 1.492-1.23 0-.56-.478-.99-1.05-1.005v-.024c.49-.061.86-.428.86-.914 0-.659-.508-1.055-1.372-1.055H6.293V14H8.44zm-.905-3.375h.498c.314 0 .501.158.501.419 0 .255-.199.422-.518.422h-.48v-.841zm0 2.523v-.97h.54c.371 0 .594.175.594.477 0 .32-.22.493-.604.493h-.53zM12.83 14h1.325l-1.38-4.228h-1.558L9.837 14h1.265l.22-.84h1.29l.219.84zm-.875-3.252h.023l.408 1.535h-.838l.407-1.535zM14.236 9.772V14h1.808c1.28 0 2.036-.791 2.036-2.145 0-1.353-.753-2.083-2.036-2.083h-1.808zm1.242.988h.39c.594 0 .946.384.946 1.095 0 .78-.325 1.158-.946 1.158h-.39V10.76z" }, null, -1 /* HOISTED */);
const _hoisted_4$3 = [
  _hoisted_2$W,
  _hoisted_3$W
];

function render$X(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$W, _hoisted_4$3))
}

const _hoisted_1$V = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$V = /*#__PURE__*/createElementVNode("path", {
  d: "M20.71 3.41l-.12-.12a1.05 1.05 0 00-.71-.29h-7.95a2 2 0 00-1.42.59l-7.22 7.22a1 1 0 000 1.41l8.49 8.49a1 1 0 001.41 0l7.22-7.22a2 2 0 00.59-1.42V4.12a1.05 1.05 0 00-.29-.71zM19 12.07l-6.51 6.52-7.08-7.08L11.93 5H19v7.07zM17 9a2 2 0 11-4 0 2 2 0 014 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$V = [
  _hoisted_2$V
];

function render$W(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$V, _hoisted_3$V))
}

const _hoisted_1$U = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$U = /*#__PURE__*/createElementVNode("path", {
  d: "M9.93 2h7.95c.265.004.518.107.71.29l.12.12c.182.192.286.445.29.71v7.95a2 2 0 01-.59 1.42l-7.22 7.22a1 1 0 01-1.41 0l-8.49-8.49a1 1 0 010-1.41l7.22-7.22A2 2 0 019.93 2zM17 11.07V4H9.93l-6.52 6.51 7.08 7.08L17 11.07zM15 8a2 2 0 10-4 0 2 2 0 004 0zm7.59-1.71l.12.12c.182.192.286.445.29.71v4.78a4 4 0 01-1.22 2.88l-7 7a.75.75 0 01-1.06 0l-.89-.89 7.58-7.57A2 2 0 0021 11.9V6h.88c.265.004.518.107.71.29z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$U = [
  _hoisted_2$U
];

function render$V(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$U, _hoisted_3$U))
}

const _hoisted_1$T = {
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$T = /*#__PURE__*/createElementVNode("path", {
  d: "M19 8H5v8h14V8zM5 6a2 2 0 00-2 2v8a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2H5z",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$T = /*#__PURE__*/createElementVNode("path", { d: "M9.427 14.5l1.52-5H9.322l-.801 3.607h-.028L7.693 9.5H6l1.52 5h1.907zM13 14.5v-5h-1.47v5H13zM13.851 9.5v5h1.471v-1.365h.715c1.169 0 1.963-.71 1.963-1.812 0-1.113-.75-1.823-1.863-1.823h-2.286zm1.471 1.105h.423c.479 0 .77.246.77.721 0 .478-.291.724-.78.724h-.413v-1.445z" }, null, -1 /* HOISTED */);
const _hoisted_4$2 = [
  _hoisted_2$T,
  _hoisted_3$T
];

function render$U(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$T, _hoisted_4$2))
}

const _hoisted_1$S = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$S = /*#__PURE__*/createElementVNode("path", {
  d: "M8.97 11.194l-.008.004-.761.447a.403.403 0 00-.126.116l-.022.039a.403.403 0 000 .396l.022.04a.403.403 0 00.126.115l6.115 3.594c.19.112.433.047.542-.145l.588-1.036a.408.408 0 00-.148-.55l-3.768-2.216 3.768-2.215a.408.408 0 00.147-.55l-.587-1.037a.393.393 0 00-.542-.145l-5.347 3.143z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$S = [
  _hoisted_2$S
];

function render$T(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$S, _hoisted_3$S))
}

const _hoisted_1$R = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$R = /*#__PURE__*/createElementVNode("path", {
  d: "M21 7.66V8a4 4 0 01-1.18 2.84L17 13.67a1.35 1.35 0 01-1.9 0l-.1-.11a.5.5 0 010-.7l3.44-3.44A2 2 0 0019 8v-.34a2 2 0 00-.59-1.42l-.65-.65A2 2 0 0016.34 5H16a2 2 0 00-1.42.59L11.14 9a.5.5 0 01-.7 0l-.11-.11a1.35 1.35 0 010-1.9l2.83-2.84A4 4 0 0116 3h.34a4 4 0 012.83 1.17l.66.66A4 4 0 0121 7.66zM8.65 13.94l5.29-5.29a.5.5 0 01.71 0l.7.7a.5.5 0 010 .71l-5.29 5.29a.5.5 0 01-.71 0l-.7-.7a.5.5 0 010-.71zM13.56 15a.5.5 0 00-.7 0l-3.43 3.41A2 2 0 018 19h-.34a2 2 0 01-1.42-.59l-.65-.65A2 2 0 015 16.34V16a2 2 0 01.59-1.42l3.42-3.44a.5.5 0 000-.7l-.11-.11a1.35 1.35 0 00-1.9 0l-2.82 2.83A4 4 0 003 16v.35a4 4 0 001.17 2.82l.66.66A4 4 0 007.66 21H8a4 4 0 002.82-1.14l2.85-2.85a1.35 1.35 0 000-1.9l-.11-.11z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$R = [
  _hoisted_2$R
];

function render$S(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$R, _hoisted_3$R))
}

const _hoisted_1$Q = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$Q = /*#__PURE__*/createElementVNode("path", { d: "M4 10a2 2 0 110 4 2 2 0 010-4zM14 12a2 2 0 10-4 0 2 2 0 004 0zM22 12a2 2 0 10-4 0 2 2 0 004 0z" }, null, -1 /* HOISTED */);
const _hoisted_3$Q = [
  _hoisted_2$Q
];

function render$R(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$Q, _hoisted_3$Q))
}

const _hoisted_1$P = {
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.0",
  fill: "currentColor",
  viewBox: "0 0 128 128",
  style: {"padding":"2px"}
};
const _hoisted_2$P = /*#__PURE__*/createStaticVNode("<g transform=\"matrix(-1 0 0 1 128 0)\"><circle cx=\"16\" cy=\"64\" r=\"13\"></circle><circle cx=\"16\" cy=\"64\" r=\"11.344\" transform=\"rotate(45 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"9.531\" transform=\"rotate(90 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"7.75\" transform=\"rotate(135 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"7.063\" transform=\"rotate(180 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"5.063\" transform=\"rotate(225 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"4.438\" transform=\"rotate(270 64 64)\"></circle><circle cx=\"16\" cy=\"64\" r=\"3.375\" transform=\"rotate(315 64 64)\"></circle><animateTransform attributeName=\"transform\" type=\"rotate\" values=\"0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64;\" calcMode=\"discrete\" dur=\"960ms\" repeatCount=\"indefinite\"></animateTransform></g>", 1);
const _hoisted_3$P = [
  _hoisted_2$P
];

function render$Q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$P, _hoisted_3$P))
}

const _hoisted_1$O = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$O = /*#__PURE__*/createElementVNode("path", {
  d: "M18 10V8A6 6 0 006 8v2a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2v-8a2 2 0 00-2-2zM8 8a4 4 0 118 0v2H8V8zm5 10a1 1 0 001-1v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1h2z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$O = [
  _hoisted_2$O
];

function render$P(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$O, _hoisted_3$O))
}

const _hoisted_1$N = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$N = /*#__PURE__*/createElementVNode("path", {
  d: "M8 10h10a2 2 0 012 2v8a2 2 0 01-2 2H6a2 2 0 01-2-2v-8a2 2 0 012-2V8a6 6 0 1112 0h-2a4 4 0 00-8 0v2zm-2 2v8h12v-8H6z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$N = [
  _hoisted_2$N
];

function render$O(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$N, _hoisted_3$N))
}

const _hoisted_1$M = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$M = /*#__PURE__*/createElementVNode("path", {
  d: "M22 6a4 4 0 00-4-4H6a4 4 0 00-4 4v15.5a.5.5 0 00.5.5.49.49 0 00.35-.15l3-3A3 3 0 018 18h10a4 4 0 004-4V6zm-4 10H8a5 5 0 00-3.54 1.46l-.46.42V6a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2zm-7.65-2.152a.48.48 0 01-.35-.152l-2.38-2.37a.5.5 0 010-.71l.53-.53a.48.48 0 01.7 0l1.5 1.49 4.74-4.74a.5.5 0 01.7 0l.53.53a.5.5 0 010 .71l-5.62 5.62a.48.48 0 01-.35.152z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$M = [
  _hoisted_2$M
];

function render$N(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$M, _hoisted_3$M))
}

const _hoisted_1$L = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$L = /*#__PURE__*/createElementVNode("path", {
  d: "M18 2a4 4 0 014 4v3.54a6.393 6.393 0 00-2-.818V6a2 2 0 00-2-2H6a2 2 0 00-2 2v11.88l.46-.42A5 5 0 018 16h4.247c.11.712.339 1.386.664 2H8a3 3 0 00-2.15.85l-3 3a.49.49 0 01-.35.15.5.5 0 01-.5-.5V6a4 4 0 014-4h12zm5.21 13a4.61 4.61 0 11-9.22 0 4.61 4.61 0 019.22 0zm-1.86 0a2.75 2.75 0 11-5.5 0 2.75 2.75 0 015.5 0z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$L = [
  _hoisted_2$L
];

function render$M(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$L, _hoisted_3$L))
}

const _hoisted_1$K = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$K = /*#__PURE__*/createElementVNode("path", {
  d: "M14.536 11.201l-.007-.004-5.347-3.142a.393.393 0 00-.542.145l-.587 1.036a.408.408 0 00.147.55l3.769 2.216L8.2 14.217a.408.408 0 00-.147.55l.587 1.037a.393.393 0 00.542.145l6.116-3.594c.05-.03.093-.07.125-.116l.022-.039a.402.402 0 000-.396l-.022-.04a.402.402 0 00-.125-.115l-.762-.447z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$K = [
  _hoisted_2$K
];

function render$L(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$K, _hoisted_3$K))
}

const _hoisted_1$J = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$J = /*#__PURE__*/createElementVNode("path", {
  d: "M6 10a2 2 0 110 4 2 2 0 010-4zm8 2a2 2 0 10-4 0 2 2 0 004 0zm4-2a2 2 0 110 4 2 2 0 010-4z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$J = [
  _hoisted_2$J
];

function render$K(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$J, _hoisted_3$J))
}

const _hoisted_1$I = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$I = /*#__PURE__*/createElementVNode("path", {
  d: "M21.783 10.38l-.17.46a3.199 3.199 0 000 2.32l.17.49a3.27 3.27 0 01-1.71 4.15l-.45.2a3.31 3.31 0 00-1.681 1.62l-.2.45a3.261 3.261 0 01-4.152 1.71l-.46-.17a3.312 3.312 0 00-2.32 0l-.46.17a3.261 3.261 0 01-4.152-1.71l-.2-.45a3.31 3.31 0 00-1.62-1.68l-.45-.2a3.27 3.27 0 01-1.711-4.15l.17-.46c.29-.746.29-1.574 0-2.32l-.17-.46a3.27 3.27 0 011.71-4.15l.45-.2a3.31 3.31 0 001.621-1.62l.23-.45a3.261 3.261 0 014.152-1.71l.46.17c.37.139.764.21 1.16.21.406.004.81-.067 1.19-.21l.46-.17a3.262 3.262 0 014.152 1.71l.2.45A3.31 3.31 0 0019.622 6l.45.23a3.27 3.27 0 011.711 4.15zm-2.98 5.77l.46-.21a1.25 1.25 0 00.66-1.6l-.17-.49a5.159 5.159 0 010-3.73l.16-.43a1.29 1.29 0 00-.66-1.64l-.44-.19A5.3 5.3 0 0116.15 5.2l-.21-.46a1.25 1.25 0 00-1.15-.74c-.155 0-.308.03-.45.09l-.49.17c-.59.23-1.218.345-1.851.34a5.063 5.063 0 01-1.88-.35l-.43-.16A1.451 1.451 0 009.21 4c-.502 0-.956.293-1.161.75l-.19.44A5.3 5.3 0 015.188 7.9l-.46.21a1.25 1.25 0 00-.65 1.6l.17.49c.465 1.2.465 2.53 0 3.73l-.16.43a1.29 1.29 0 00.66 1.64l.44.14a5.3 5.3 0 012.66 2.66l.21.46A1.25 1.25 0 009.21 20c.155 0 .308-.03.45-.09l.49-.17A5.003 5.003 0 0112 19.4a5.063 5.063 0 011.88.35l.43.16c.155.057.317.087.48.09.502 0 .956-.293 1.161-.75l.19-.44a5.301 5.301 0 012.661-2.66zM11.5 14a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zm-.18-6h1.36a.5.5 0 01.5.56l-.4 3.22a.25.25 0 01-.25.22h-1.06a.25.25 0 01-.25-.22l-.4-3.22a.5.5 0 01.5-.56z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$I = [
  _hoisted_2$I
];

function render$J(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$I, _hoisted_3$I))
}

const _hoisted_1$H = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$H = /*#__PURE__*/createElementVNode("path", {
  d: "M18.88 14.88l.83.83a1 1 0 01.29.7V17a1 1 0 01-1 1H5a1 1 0 01-1-1v-.59a1 1 0 01.29-.7l.83-.83A3 3 0 006 12.76V10a6 6 0 011.2-3.6l.9-1.2A3 3 0 0110.5 4h.5V2.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V4h.5a3 3 0 012.4 1.2l.9 1.2A6 6 0 0118 10v2.76a3 3 0 00.88 2.12zM12 22a2 2 0 002-2h-4a2 2 0 002 2z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$H = [
  _hoisted_2$H
];

function render$I(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$H, _hoisted_3$H))
}

const _hoisted_1$G = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$G = /*#__PURE__*/createElementVNode("path", {
  d: "M6.844 17.854l-.7-.703a.5.5 0 010-.704l8.48-8.456-6.212.007a.492.492 0 01-.496-.5l.007-.991a.5.5 0 01.496-.5L16.994 6c.196 0 .385.078.524.218l.265.267c.137.142.215.33.217.528l-.007 8.633a.499.499 0 01-.496.5h-.992a.482.482 0 01-.49-.493l.007-6.255-8.48 8.456a.492.492 0 01-.698 0z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$G = [
  _hoisted_2$G
];

function render$H(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$G, _hoisted_3$G))
}

const _hoisted_1$F = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$F = /*#__PURE__*/createElementVNode("path", {
  d: "M21 19v-5.5a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5V19H5V5h5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5H5a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2zm-.49-15.77l.27.27v-.01A.75.75 0 0121 4v6.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V6.42l-8.44 8.43a.5.5 0 01-.71 0l-.7-.7a.5.5 0 010-.71L17.59 5H13.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H20a.75.75 0 01.51.23z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$F = [
  _hoisted_2$F
];

function render$G(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$F, _hoisted_3$F))
}

const _hoisted_1$E = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$E = /*#__PURE__*/createElementVNode("path", {
  d: "M15 3H5a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2zm0 2v14H5V5h10zm6 13V6a1 1 0 00-1-1h-1v14h1a1 1 0 001-1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$E = [
  _hoisted_2$E
];

function render$F(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$E, _hoisted_3$E))
}

const _hoisted_1$D = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$D = /*#__PURE__*/createElementVNode("path", {
  d: "M10 17.25V6.75A.76.76 0 009.25 6h-1.5a.76.76 0 00-.75.75v10.5a.76.76 0 00.75.75h1.5a.76.76 0 00.75-.75zM14.75 6h1.5a.76.76 0 01.75.75v10.5a.76.76 0 01-.75.75h-1.5a.76.76 0 01-.75-.75V6.75a.76.76 0 01.75-.75z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$D = [
  _hoisted_2$D
];

function render$E(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$D, _hoisted_3$D))
}

const _hoisted_1$C = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$C = /*#__PURE__*/createElementVNode("path", {
  d: "M14.675 4.6l.544-1.257a.991.991 0 00-.04-.911.817.817 0 00-.739-.421L9.5 2a.813.813 0 00-.704.423.99.99 0 00-.047.88l.55 1.26c.155.358.201.762.13 1.15l-.623 3.441a2.822 2.822 0 01-.685 1.426l-.875.96a.956.956 0 00-.246.646l.025.555c.002.502.373.91.83.912l8.312.025c.458 0 .828-.407.828-.909l.005-.536a.964.964 0 00-.248-.646l-.878-.964a2.848 2.848 0 01-.691-1.43l-.636-3.443a1.986 1.986 0 01.128-1.15zM10.967 20.047a2.98 2.98 0 01-.196-1.079l-.007-3.771 2.424.057.007 3.758a2.97 2.97 0 01-.193 1.079l-.638 1.632a.415.415 0 01-.382.277.42.42 0 01-.383-.279l-.632-1.674z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$C = [
  _hoisted_2$C
];

function render$D(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$C, _hoisted_3$C))
}

const _hoisted_1$B = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$B = /*#__PURE__*/createElementVNode("path", {
  d: "M18 11.86v.28a.76.76 0 01-.37.65L8.68 18c-.54.32-.82.32-1.06.18l-.25-.14a.76.76 0 01-.37-.63V6.59a.76.76 0 01.37-.65l.25-.14c.24-.14.52-.14 1.22.27l8.79 5.14a.76.76 0 01.37.65z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$B = [
  _hoisted_2$B
];

function render$C(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$B, _hoisted_3$B))
}

const _hoisted_1$A = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$A = /*#__PURE__*/createElementVNode("path", {
  d: "M2 12C2 6.477 6.477 2 12 2A10 10 0 112 12zm8.17 4.28L16 12.64a.76.76 0 000-1.28l-5.85-3.64A.75.75 0 009 8.35v7.3a.75.75 0 001.17.63z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$A = [
  _hoisted_2$A
];

function render$B(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$A, _hoisted_3$A))
}

const _hoisted_1$z = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$z = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zM9.39 7.697a.75.75 0 01.76.023L16 11.36a.76.76 0 010 1.28l-5.85 3.64A.75.75 0 019 15.65v-7.3a.75.75 0 01.39-.653z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$z = [
  _hoisted_2$z
];

function render$A(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$z, _hoisted_3$z))
}

const _hoisted_1$y = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$y = /*#__PURE__*/createElementVNode("path", {
  d: "M8.009 5.08a.212.212 0 00.072.227l1.926 1.742-.576 2.629a.22.22 0 00.076.223l.088.063a.192.192 0 00.224 0l2.186-1.4 2.174 1.387a.192.192 0 00.223 0l.116-.067a.22.22 0 00.076-.223l-.591-2.612 1.926-1.742a.213.213 0 00.06-.227l-.032-.105a.198.198 0 00-.176-.148l-2.553-.214-.983-2.478a.196.196 0 00-.188-.134h-.104a.203.203 0 00-.204.134l-.979 2.478-2.554.214a.198.198 0 00-.175.148l-.032.105zM10 12h4a1 1 0 011 1v8H9v-8a1 1 0 011-1zm6 8v-5h3a1 1 0 011 1v4a1 1 0 01-1 1h-3v-1zM5 15h3v6H5a1 1 0 01-1-1v-4a1 1 0 011-1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$y = [
  _hoisted_2$y
];

function render$z(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$y, _hoisted_3$y))
}

const _hoisted_1$x = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$x = /*#__PURE__*/createElementVNode("path", {
  d: "M8.928 15.795a.5.5 0 01-.148.355l-.71.7a.5.5 0 01-.71 0l-4.14-4.13a.75.75 0 01-.22-.53v-.38a.77.77 0 01.22-.53l4.13-4.13a.5.5 0 01.71 0l.71.71a.49.49 0 010 .7L5.33 12l3.45 3.44a.5.5 0 01.148.355zm7.357-8.793a.5.5 0 00-.355.148l-.71.7a.5.5 0 000 .71L18.67 12l-3.45 3.44a.49.49 0 000 .7l.71.71a.5.5 0 00.71 0l4.14-4.13a.77.77 0 00.22-.53v-.38a.75.75 0 00-.22-.53l-4.14-4.13a.5.5 0 00-.355-.148z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$x = [
  _hoisted_2$x
];

function render$y(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$x, _hoisted_3$x))
}

const _hoisted_1$w = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$w = /*#__PURE__*/createElementVNode("path", {
  d: "M5.5 13.25c-.276 0-.5-.28-.5-.625v-1.25c0-.345.224-.625.5-.625h13c.276 0 .5.28.5.625v1.25c0 .345-.224.625-.5.625h-13z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$w = [
  _hoisted_2$w
];

function render$x(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$w, _hoisted_3$w))
}

const _hoisted_1$v = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$v = /*#__PURE__*/createElementVNode("path", {
  d: "M10 16.58a.49.49 0 01-.15.36l-.2.2a.5.5 0 01-.71 0l-5.79-5.79a.48.48 0 010-.7l5.79-5.79a.5.5 0 01.71 0l.2.2a.49.49 0 01.15.36V8a11.22 11.22 0 0111 10.54.5.5 0 01-.12.33.46.46 0 01-.32.13h-.1a.5.5 0 01-.49-.41C19.5 16 14.72 14 10 14v2.58z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$v = [
  _hoisted_2$v
];

function render$w(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$v, _hoisted_3$v))
}

const _hoisted_1$u = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$u = /*#__PURE__*/createElementVNode("path", {
  d: "M22 12a9 9 0 01-9 9 8.89 8.89 0 01-5.16-1.63.5.5 0 01-.07-.76l.72-.73a.5.5 0 01.63-.06A6.91 6.91 0 0013 19a7 7 0 10-7-7h2.36a.49.49 0 01.36.15l.2.2a.5.5 0 010 .71L5.39 16.6a.51.51 0 01-.71 0l-3.53-3.54a.5.5 0 010-.71l.2-.2a.49.49 0 01.36-.15H4a9 9 0 0118 0z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$u = [
  _hoisted_2$u
];

function render$v(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$u, _hoisted_3$u))
}

const _hoisted_1$t = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$t = /*#__PURE__*/createElementVNode("path", {
  d: "M19.071 4.929c3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0z",
  fill: "#F0F0F0"
}, null, -1 /* HOISTED */);
const _hoisted_3$t = /*#__PURE__*/createElementVNode("path", {
  d: "M21.378 15.478A9.978 9.978 0 0022 12c0-1.223-.22-2.395-.622-3.479H2.622A9.978 9.978 0 002 12c0 1.223.22 2.395.622 3.478l9.379.87 9.377-.87z",
  fill: "#0052B4"
}, null, -1 /* HOISTED */);
const _hoisted_4$1 = /*#__PURE__*/createElementVNode("path", {
  d: "M12 22c4.3 0 7.966-2.713 9.379-6.521H2.623A10.004 10.004 0 0012 22z",
  fill: "#D80027"
}, null, -1 /* HOISTED */);
const _hoisted_5 = [
  _hoisted_2$t,
  _hoisted_3$t,
  _hoisted_4$1
];

function render$u(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$t, _hoisted_5))
}

const _hoisted_1$s = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$s = /*#__PURE__*/createElementVNode("path", {
  d: "M12.996 6a4 4 0 11-7.998.001A4 4 0 0112.996 6zm-2 0a2 2 0 10-3.998 0 2 2 0 003.999 0zm4.75 8.42l1.249-1.25V10a1 1 0 10-2 0v3.5c.321.241.578.557.75.92zm4.288-2.426a1 1 0 01.71.296h-.04a1 1 0 010 1.42l-5.559 5.56c-.47.468-1.106.73-1.769.73H9.298a1 1 0 00-.7.29l-1.42 1.42a1 1 0 01-1.41 0L3.29 19.23a1 1 0 010-1.41l2.829-2.91A3.318 3.318 0 018.708 14h4.688a1.57 1.57 0 011.6 1.35 1.49 1.49 0 01-1.27 1.65H9.497a.5.5 0 000 1h3.999a2.5 2.5 0 002.5-2.41l3.328-3.3a1 1 0 01.71-.296z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$s = [
  _hoisted_2$s
];

function render$t(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$s, _hoisted_3$s))
}

const _hoisted_1$r = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$r = /*#__PURE__*/createElementVNode("path", {
  d: "M16.333 15.072l3.556 3.56a.445.445 0 01-.018.613l-.622.623a.445.445 0 01-.631 0l-3.556-3.56a2.303 2.303 0 01-.266-.32l-.667-.89a6.218 6.218 0 01-3.885 1.362A6.232 6.232 0 017.531 4.613a6.217 6.217 0 017.572 1.753 6.235 6.235 0 01-.04 7.78l.888.614c.139.089.267.194.382.312zM5.8 10.23c0 2.458 1.99 4.45 4.445 4.45 1.178 0 2.309-.469 3.142-1.303a4.453 4.453 0 00-3.142-7.597 4.447 4.447 0 00-4.445 4.45z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$r = [
  _hoisted_2$r
];

function render$s(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$r, _hoisted_3$r))
}

const _hoisted_1$q = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$q = /*#__PURE__*/createElementVNode("path", {
  d: "M19.968 4.949l-5.99 16.722a.5.5 0 01-.469.329h-.16a.51.51 0 01-.459-.29l-2.355-4.991a1.997 1.997 0 01.339-2.206l2.995-3.275a.5.5 0 000-.688l-.38-.38a.5.5 0 00-.689 0l-3.274 2.995a1.996 1.996 0 01-2.206.34l-4.99-2.357A.51.51 0 012 10.69v-.16a.5.5 0 01.33-.509l16.72-5.99a.499.499 0 01.518.11l.26.26a.5.5 0 01.14.549z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$q = [
  _hoisted_2$q
];

function render$r(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$q, _hoisted_3$q))
}

const _hoisted_1$p = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$p = /*#__PURE__*/createElementVNode("path", {
  d: "M20.21 14.074a2.005 2.005 0 01-.72-1.643v-.861c-.032-.632.235-1.24.72-1.644l.8-.661c.376-.312.473-.85.23-1.273l-1.16-2.004a1 1 0 00-.86-.501.838.838 0 00-.35.07l-1 .36c-.223.088-.46.133-.7.131a1.997 1.997 0 01-1.08-.32 5.479 5.479 0 00-.74-.431 2.004 2.004 0 01-1.06-1.453l-.17-1.002a1 1 0 00-1-.842h-2.3a1 1 0 00-1 .842l-.17 1.002a2.004 2.004 0 01-1.02 1.453 5.477 5.477 0 00-.74.43c-.322.209-.697.32-1.08.321a1.887 1.887 0 01-.7-.13l-1-.36a.839.839 0 00-.35-.071 1 1 0 00-.86.501L2.76 7.992c-.241.426-.14.964.24 1.273l.8.66c.485.404.752 1.013.72 1.644v.861c.032.632-.235 1.24-.72 1.644l-.8.661c-.38.309-.481.847-.24 1.273l1.16 2.004a1 1 0 00.86.501c.12.002.24-.022.35-.07l1-.36c.223-.088.46-.133.7-.131.383 0 .758.112 1.08.32.235.163.483.307.74.431.563.29.956.828 1.06 1.453l.17 1.002a1 1 0 001 .842h2.3a1 1 0 001-.842l.17-1.002a2.004 2.004 0 011.06-1.453c.258-.124.505-.268.74-.43.322-.209.697-.32 1.08-.321.24-.002.477.043.7.13l1 .36c.11.05.23.073.35.071a1 1 0 00.86-.501l1.16-2.004c.228-.44.1-.981-.3-1.273l-.79-.66zM12 17.511A5.506 5.506 0 016.5 12 5.506 5.506 0 0112 6.489c3.038 0 5.5 2.467 5.5 5.511 0 1.462-.58 2.863-1.61 3.897A5.494 5.494 0 0112 17.51zM10 12c0-1.107.896-2.004 2-2.004 1.105 0 2 .897 2 2.004a2.002 2.002 0 01-2 2.004c-1.104 0-2-.897-2-2.004z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$p = [
  _hoisted_2$p
];

function render$q(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$p, _hoisted_3$p))
}

const _hoisted_1$o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$o = /*#__PURE__*/createElementVNode("path", {
  d: "M19.5 5h-15a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v1a.5.5 0 01-.5.5zm2.29 5.58l-1.51-3a1 1 0 00-.9-.55H4.62a1 1 0 00-.9.55l-1.51 3a2 2 0 00-.21.89V12a1 1 0 001 1h1v7a1 1 0 001 1h5a1 1 0 001-1v-2.75a.25.25 0 01.25-.25h1.5a.25.25 0 01.25.25V20a1 1 0 001 1h5a1 1 0 001-1v-7h1a1 1 0 001-1v-.53a2 2 0 00-.21-.89zM18 19h-3v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3H6v-6h12v6z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$o = [
  _hoisted_2$o
];

function render$p(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$o, _hoisted_3$o))
}

const _hoisted_1$n = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$n = /*#__PURE__*/createElementVNode("path", {
  d: "M17 7h3a1 1 0 011 1v12a2 2 0 01-2 2H5a2 2 0 01-2-2V8a1 1 0 011-1h3a5 5 0 0110 0zm-8.5 4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zM12 4a3 3 0 013 3H9a3 3 0 013-3zm4.5 7a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$n = [
  _hoisted_2$n
];

function render$o(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$n, _hoisted_3$n))
}

const _hoisted_1$m = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$m = /*#__PURE__*/createElementVNode("path", {
  d: "M18.5 10h4a.5.5 0 01.47.5v1a.5.5 0 01-.5.5H22l-1.68 7.65A3 3 0 0117.4 22H6.6a3 3 0 01-2.89-2.35L2 12h-.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h4l5.77-7.7a.77.77 0 01.6-.3h.26a.77.77 0 01.6.3L18.5 10zM12 4.67L8 10h8l-4-5.33z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$m = [
  _hoisted_2$m
];

function render$n(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$m, _hoisted_3$m))
}

const _hoisted_1$l = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$l = /*#__PURE__*/createElementVNode("path", {
  d: "M23 10.5a.5.5 0 00-.5-.5h-4l-5.77-7.7a.77.77 0 00-.6-.3h-.26a.77.77 0 00-.6.3L5.5 10h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5H2l1.71 7.65A3 3 0 006.6 22h10.8a3 3 0 002.92-2.35L22 12h.47a.5.5 0 00.5-.5l.03-1zM8 10l4-5.33L16 10H8zm4.88 6.88h1.62a.5.5 0 00.5-.5v-.76a.5.5 0 00-.5-.5h-1.62V13.5a.5.5 0 00-.5-.5h-.76a.5.5 0 00-.5.5v1.62H9.5a.5.5 0 00-.5.5v.76a.5.5 0 00.5.5h1.62v1.62a.5.5 0 00.5.5h.76a.5.5 0 00.5-.5v-1.62z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$l = [
  _hoisted_2$l
];

function render$m(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$l, _hoisted_3$l))
}

const _hoisted_1$k = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$k = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm1-10a2 2 0 114 0v.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V10zm-2.5 1a.5.5 0 00.5-.5V10a2 2 0 10-4 0v.5a.5.5 0 00.5.5h3zm4.93 2.49l.87.51a.51.51 0 01.24.33.49.49 0 01-.08.39 5.49 5.49 0 01-8.92 0 .49.49 0 01-.08-.39.51.51 0 01.24-.33l.87-.51a.51.51 0 01.65.13 3.48 3.48 0 005.56 0 .51.51 0 01.65-.13z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$k = [
  _hoisted_2$k
];

function render$l(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$k, _hoisted_3$k))
}

const _hoisted_1$j = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$j = /*#__PURE__*/createElementVNode("path", {
  d: "M6 3h12a4 4 0 014 4v8a4 4 0 01-4 4H8a3 3 0 00-2.15.85l-3 3a.49.49 0 01-.35.15.5.5 0 01-.5-.5V7a4 4 0 014-4zm2.5 9a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1zm4.5-.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm3.5.5a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$j = [
  _hoisted_2$j
];

function render$k(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$j, _hoisted_3$j))
}

const _hoisted_1$i = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$i = /*#__PURE__*/createElementVNode("path", {
  d: "M19.016 11.986a3.999 3.999 0 01-4.003 3.994H6.005a3.007 3.007 0 00-2.152.849L1.85 18.826a.49.49 0 01-.35.15.5.5 0 01-.501-.5V5.995A3.999 3.999 0 015.004 2h10.009a3.999 3.999 0 014.003 3.994v5.992zM3.002 5.994v8.988a5.012 5.012 0 013.003-1h9.008a2 2 0 002.002-1.996V5.994a2 2 0 00-2.002-1.997H5.003a2 2 0 00-2.001 1.997zm10.51 3.995h1a.5.5 0 00.5-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5zm-3.003 0H9.508a.5.5 0 01-.5-.5v-.998a.5.5 0 01.5-.5h1a.5.5 0 01.501.5v.998a.5.5 0 01-.5.5zm-3.504-.5v-.998a.5.5 0 00-.5-.5h-1a.5.5 0 00-.501.5v.998a.5.5 0 00.5.5h1.001a.5.5 0 00.5-.5zm10.01 8.488a3.999 3.999 0 004.003-3.994V5.994A2 2 0 0123 7.991v14.51a.5.5 0 01-.5.499.491.491 0 01-.35-.15l-2.003-1.997a3.006 3.006 0 00-2.131-.879H7.005a2 2 0 01-2.002-1.997h12.01z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$i = [
  _hoisted_2$i
];

function render$j(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$i, _hoisted_3$i))
}

const _hoisted_1$h = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$h = /*#__PURE__*/createElementVNode("path", {
  d: "M2.201 9.854a.49.49 0 01-.18-.54l.08-.249a.49.49 0 01.44-.35l6.384-.51 2.448-5.884a.51.51 0 01.51-.32h.259a.49.49 0 01.47.32l2.457 5.885 6.384.51a.49.49 0 01.44.349l.08.25a.49.49 0 01-.15.54l-4.816 4.136 1.479 6.204a.51.51 0 01-.19.53l-.29.16a.5.5 0 01-.56 0l-5.434-3.298-5.465 3.327a.5.5 0 01-.56 0l-.219-.15a.51.51 0 01-.19-.53l1.439-6.244L2.2 9.855z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$h = [
  _hoisted_2$h
];

function render$i(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$h, _hoisted_3$h))
}

const _hoisted_1$g = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$g = /*#__PURE__*/createElementVNode("path", {
  d: "M16 18H8a2 2 0 01-2-2V8a2 2 0 012-2h8a2 2 0 012 2v8a2 2 0 01-2 2z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$g = [
  _hoisted_2$g
];

function render$h(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$g, _hoisted_3$g))
}

const _hoisted_1$f = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$f = /*#__PURE__*/createElementVNode("path", {
  d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16zm.88-13.5v5.14l3.63 3.63a.51.51 0 010 .71l-.53.53a.51.51 0 01-.71 0l-4-4a.53.53 0 01-.15-.35V6.5a.5.5 0 01.5-.5h.76a.5.5 0 01.5.5z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$f = [
  _hoisted_2$f
];

function render$g(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$f, _hoisted_3$f))
}

const _hoisted_1$e = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$e = /*#__PURE__*/createElementVNode("path", {
  d: "M8 7h8a5 5 0 010 10H8A5 5 0 018 7zm8-1H8a6 6 0 100 12h8a6 6 0 000-12zM4 12a4 4 0 108 0 4 4 0 00-8 0z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$e = [
  _hoisted_2$e
];

function render$f(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$e, _hoisted_3$e))
}

const _hoisted_1$d = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$d = /*#__PURE__*/createElementVNode("path", {
  d: "M21 7c0 2.2-1.8 4-4 4-.5 0-1.1-.1-1.5-.3l-1.7 1.7 1.2 1.2.5-.5c.2-.2.5-.2.7 0l4.5 4.5c.2.2.3.4.3.7v1.2c0 .3-.1.5-.3.7l-.5.5c-.2.2-.4.3-.7.3h-1.2c-.3 0-.5-.1-.7-.3l-4.5-4.5c-.2-.2-.2-.5 0-.7l.5-.5-6.8-6.8-1.6-.9c-.3-.1-.6-.3-.7-.7l-1.4-2c-.1-.2-.1-.4.1-.6l.8-.8c.2-.2.4-.2.6-.1l2.1 1.3c.3.2.5.5.6.8l.9 1.6 3.4 3.5 1.7-1.7c-.2-.5-.3-1.1-.3-1.6 0-2.2 1.8-4 4-4h.3c.2 0 .3 0 .4.1l.2.2c.2.2.2.5 0 .7l-1.6 1.6c-.2.2-.2.5 0 .7l1.4 1.4c.2.2.5.2.7 0L20 6.1c.2-.1.5-.1.7 0l.2.2c0 .05.025.125.05.2.025.075.05.15.05.2V7zM3 19.3c0-.3.1-.5.3-.7L9 12.9l2.1 2.1-5.7 5.7c-.2.2-.4.3-.7.3h-.2c-.2 0-.5-.1-.7-.3l-.5-.5c-.2-.2-.3-.4-.3-.7v-.2z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$d = [
  _hoisted_2$d
];

function render$e(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$d, _hoisted_3$d))
}

const _hoisted_1$c = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$c = /*#__PURE__*/createElementVNode("path", {
  d: "M20.605 14.56V20c0 .56-.44 1-1 1h-15.2c-.56 0-1-.44-1-1v-5.44c0-.56.44-1 1-1s1 .44 1 1V19h13.2v-4.44c0-.56.44-1 1-1s1 .44 1 1zM8.725 8.78l2.28-2.32v8.66c0 .56.44 1 1 1s1-.44 1-1V6.46l2.28 2.32c.2.2.46.3.72.3s.5-.1.7-.28c.4-.38.4-1.02.02-1.42l-3.98-4.08a.95.95 0 00-.72-.3c-.26 0-.52.1-.72.3l-3.98 4.08c-.38.4-.38 1.02.02 1.42.36.38 1 .36 1.38-.02z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$c = [
  _hoisted_2$c
];

function render$d(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$c, _hoisted_3$c))
}

const _hoisted_1$b = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$b = /*#__PURE__*/createElementVNode("path", {
  d: "M12.003 4a4 4 0 104.001 4 4 4 0 00-4.001-4zm6.452 11.66l1.44 2.89a1 1 0 01-.89 1.45H5a1 1 0 01-.89-1.45l1.44-2.89A3.001 3.001 0 018.242 14h7.522a3.001 3.001 0 012.691 1.66z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$b = [
  _hoisted_2$b
];

function render$c(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$b, _hoisted_3$b))
}

const _hoisted_1$a = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$a = /*#__PURE__*/createElementVNode("path", {
  d: "M9 12a4 4 0 100-8 4 4 0 000 8zm7.89 6.55A1 1 0 0116 20H2a1 1 0 01-.89-1.45l1.44-2.89A3 3 0 015.24 14h7.52a3 3 0 012.69 1.66l1.44 2.89zM20 10h2.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5H20v2.5a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5V12h-2.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5H18V7.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5V10z",
  fill: "currentColor"
}, null, -1 /* HOISTED */);
const _hoisted_3$a = [
  _hoisted_2$a
];

function render$b(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$a, _hoisted_3$a))
}

const _hoisted_1$9 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$9 = /*#__PURE__*/createElementVNode("path", {
  d: "M16.004 8A4 4 0 118 7.998 4 4 0 0116.004 8zm-2 0a2 2 0 10-4.001 0 2 2 0 004 0zm5.892 10.55l-1.89-3.89A3.001 3.001 0 0015.263 13H8.742a3.001 3.001 0 00-2.691 1.66L4.11 18.55A1 1 0 005 20h14.006a1 1 0 00.89-1.45zm-12.055-3L6.621 18h10.764l-1.22-2.45a1 1 0 00-.9-.55H8.741a1 1 0 00-.9.55z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$9 = [
  _hoisted_2$9
];

function render$a(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$9, _hoisted_3$9))
}

const _hoisted_1$8 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$8 = /*#__PURE__*/createElementVNode("path", {
  d: "M6 4.496A2.498 2.498 0 018.503 2c1.38 0 2.5 1.117 2.5 2.496a2.503 2.503 0 01-4.27 1.765 2.494 2.494 0 01-.731-1.765zm7.894 8.037l-1-1.897a3.001 3.001 0 00-2.632-1.647h-3.52c-1.135 0-2.172.637-2.682 1.647l-.95 1.897A.997.997 0 004 13.981h9.003a1 1 0 00.89-1.448zm4.11-8.037a2.498 2.498 0 01-2.5 2.496 2.493 2.493 0 01-1.771-.728A2.498 2.498 0 0115.504 2c1.381 0 2.5 1.117 2.5 2.496zm2.892 8.037l-.95-1.897a3.002 3.002 0 00-2.681-1.647h-3.001c.183.237.344.491.48.759l.95 1.886a2.99 2.99 0 01.13 2.347h4.182a1 1 0 00.89-1.448zm-7.283 3.444h3.892a.52.52 0 01.57.5v3.883a.49.49 0 01-.85.35l-1-.998a7.01 7.01 0 01-6.95 2.061 6.995 6.995 0 01-5.055-5.186.528.528 0 01.1-.42.49.49 0 01.39-.19h1a.5.5 0 01.481.32 5.008 5.008 0 008.533 1.997l-1.46-1.468a.498.498 0 01.35-.849z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$8 = [
  _hoisted_2$8
];

function render$9(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$8, _hoisted_3$8))
}

const _hoisted_1$7 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$7 = /*#__PURE__*/createElementVNode("path", {
  d: "M11.994 5a10.643 10.643 0 019.994 6.7c.016.1.016.2 0 .3a.81.81 0 01-.06.33A10.644 10.644 0 0111.994 19c-4.37.022-8.31-2.63-9.934-6.69A.81.81 0 012 12a1 1 0 01.06-.33A10.643 10.643 0 0111.994 5zm-2.998 7a3 3 0 102.998-3 3 3 0 00-2.998 3z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$7 = [
  _hoisted_2$7
];

function render$8(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$7, _hoisted_3$7))
}

const _hoisted_1$6 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$6 = /*#__PURE__*/createElementVNode("path", {
  d: "M19 7H6a1 1 0 010-2h13a2 2 0 00-2-2H6a3 3 0 00-3 3v13a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2zM5 19V9h14v2h-7a1 1 0 00-1 1v4a1 1 0 001 1h7v2H5zm10-4.5v-1a.5.5 0 00-.5-.5h-1a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$6 = [
  _hoisted_2$6
];

function render$7(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$6, _hoisted_3$6))
}

const _hoisted_1$5 = {
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$5 = /*#__PURE__*/createElementVNode("path", { d: "M11.553 2.106a1 1 0 01.894 0l9 4.5a1 1 0 11-.894 1.788L12 4.118 3.447 8.394a1 1 0 11-.894-1.788l9-4.5z" }, null, -1 /* HOISTED */);
const _hoisted_3$5 = /*#__PURE__*/createElementVNode("path", {
  d: "M11.553 5.606a1 1 0 01.894 0l9 4.5A1 1 0 0122 11v10a1 1 0 01-1 1H3a1 1 0 01-1-1V11a1 1 0 01.553-.894l9-4.5zM20 20h-3v-3a1 1 0 00-1-1h-1v-3a1 1 0 00-1-1h-4a1 1 0 00-1 1v3H8a1 1 0 00-1 1v3H4v-8.382l8-4 8 4V20zm-9-4h2v-2h-2v2zm-2 2v2h2v-2H9zm4 0v2h2v-2h-2z",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_4 = [
  _hoisted_2$5,
  _hoisted_3$5
];

function render$6(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$5, _hoisted_4))
}

const _hoisted_1$4 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2$4 = /*#__PURE__*/createElementVNode("path", {
  d: "M22.905 19.63L12.813 2.37a.76.76 0 00-.65-.37h-.3a.76.76 0 00-.65.37L1.1 19.63a.79.79 0 000 .76l.14.23a.73.73 0 00.65.38h20.225a.73.73 0 00.65-.38l.14-.23a.79.79 0 000-.76zm-9.902-3.13a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1zm-.47-3.5a.25.25 0 00.25-.22l.4-3.22a.5.5 0 00-.5-.56h-1.36a.5.5 0 00-.5.56l.4 3.22a.25.25 0 00.25.22h1.06z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$4 = [
  _hoisted_2$4
];

function render$5(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$4, _hoisted_3$4))
}

const _hoisted_1$3 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$3 = /*#__PURE__*/createElementVNode("path", {
  d: "M20 4H4a2 2 0 00-2 2v12a2 2 0 002 2h16a2 2 0 002-2V6a2 2 0 00-2-2zm0 14H4V8h16v10zm-9.5-2h-4a.5.5 0 01-.5-.5v-5a.5.5 0 01.5-.5h4a.5.5 0 01.5.5v5a.5.5 0 01-.5.5zm3-4h4a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-4a.5.5 0 00-.5.5v1a.5.5 0 00.5.5zm2 4h-2a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h2a.5.5 0 01.5.5v1a.5.5 0 01-.5.5z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$3 = [
  _hoisted_2$3
];

function render$4(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$3, _hoisted_3$3))
}

const _hoisted_1$2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$2 = /*#__PURE__*/createElementVNode("path", {
  d: "M20.875 19.46l-4-4.005a2.437 2.437 0 00-.43-.35l-1-.691a7.015 7.015 0 00.046-8.753 6.995 6.995 0 00-8.518-1.972 7.011 7.011 0 003.052 13.328c1.588 0 3.13-.54 4.37-1.532l.75 1.001c.089.13.19.25.3.36l4 4.006a.5.5 0 00.71 0l.7-.701a.501.501 0 00.02-.691zm-10.85-4.446c-2.761 0-5-2.24-5-5.006a5.003 5.003 0 015-5.006 5.009 5.009 0 013.535 8.546 4.997 4.997 0 01-3.535 1.467zM8.5 10a1 1 0 11-2 0 1 1 0 012 0zm2.5 0a1 1 0 11-2 0 1 1 0 012 0zm1.5 1a1 1 0 100-2 1 1 0 000 2z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$2 = [
  _hoisted_2$2
];

function render$3(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$2, _hoisted_3$2))
}

const _hoisted_1$1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2$1 = /*#__PURE__*/createElementVNode("path", {
  d: "M20.875 19.46l-4-4.005a2.437 2.437 0 00-.43-.35l-1-.691a7.015 7.015 0 00.046-8.753 6.995 6.995 0 00-8.518-1.972 7.011 7.011 0 003.052 13.328c1.588 0 3.13-.54 4.37-1.532l.75 1.001c.089.13.19.25.3.36l4 4.006a.5.5 0 00.71 0l.7-.701a.501.501 0 00.02-.691zm-10.85-4.446c-2.761 0-5-2.24-5-5.006a5.003 5.003 0 015-5.006 5.009 5.009 0 013.535 8.546 4.997 4.997 0 01-3.535 1.467zm2.5-5.887a.5.5 0 01.5.501v.76a.5.5 0 01-.5.502h-1.62v1.621a.5.5 0 01-.5.501h-.76a.5.5 0 01-.5-.5v-1.623h-1.62a.5.5 0 01-.5-.5v-.761a.5.5 0 01.5-.5h1.62V7.504a.5.5 0 01.5-.5h.76a.5.5 0 01.5.5v1.622h1.62z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3$1 = [
  _hoisted_2$1
];

function render$2(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1$1, _hoisted_3$1))
}

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /*#__PURE__*/createElementVNode("path", {
  d: "M20.875 19.46l-4-4.005a2.437 2.437 0 00-.43-.35l-1-.691a7.015 7.015 0 00.046-8.753 6.995 6.995 0 00-8.518-1.972 7.011 7.011 0 003.052 13.328c1.588 0 3.13-.54 4.37-1.532l.75 1.001c.089.13.19.25.3.36l4 4.006a.5.5 0 00.71 0l.7-.701a.501.501 0 00.02-.691zm-10.85-4.446c-2.761 0-5-2.24-5-5.006a5.003 5.003 0 015-5.006 5.009 5.009 0 013.535 8.546 4.997 4.997 0 01-3.535 1.467zm-3-5.386a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v.76a.5.5 0 01-.5.502h-5a.5.5 0 01-.5-.501v-.761z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd"
}, null, -1 /* HOISTED */);
const _hoisted_3 = [
  _hoisted_2
];

function render$1(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3))
}

const icons = {
    OmnicaIconAccountCircle: render$1U,
    OmnicaIconAdd: render$1T,
    OmnicaIconAddCircle: render$1S,
    OmnicaIconAddCircleOutlined: render$1R,
    OmnicaIconAllDone: render$1Q,
    OmnicaIconArrowBackward: render$1P,
    OmnicaIconArrowDoublesidedHorizontal2: render$1O,
    OmnicaIconArrowLongRight: render$1N,
    OmnicaIconAttachment: render$1M,
    OmnicaIconAttachmentDiagonal: render$1L,
    OmnicaIconBlocked: render$1K,
    OmnicaIconCalendar: render$1J,
    OmnicaIconCalendarMonth: render$1I,
    OmnicaIconCallTalking: render$1H,
    OmnicaIconCaretDown: render$1G,
    OmnicaIconCaretUp: render$1F,
    OmnicaIconChartPie1: render$1E,
    OmnicaIconCheckmarkCircle: render$1D,
    OmnicaIconCheckmarkCircleOutlined: render$1C,
    OmnicaIconCheckmarkSquareOutlined: render$1B,
    OmnicaIconChevronDown: render$1A,
    OmnicaIconChevronRight: render$1z,
    OmnicaIconChevronUp: render$1y,
    OmnicaIconClear: render$1x,
    OmnicaIconClearCircle: render$1w,
    OmnicaIconClearCircleOutlined: render$1v,
    OmnicaIconCode: render$1u,
    OmnicaIconColor: render$1t,
    OmnicaIconCopy: render$1s,
    OmnicaIconCreditCardAdd: render$1r,
    OmnicaIconDelete: render$1q,
    OmnicaIconDeleteOutlined: render$1p,
    OmnicaIconDiamond: render$1o,
    OmnicaIconDiscount: render$1n,
    OmnicaIconDiscountOutlined: render$1m,
    OmnicaIconDone: render$1l,
    OmnicaIconDoubleCaretVertical: render$1k,
    OmnicaIconDownloadTo: render$1j,
    OmnicaIconEarthEast: render$1i,
    OmnicaIconEdit: render$1h,
    OmnicaIconEmail: render$1g,
    OmnicaIconEqual: render$1f,
    OmnicaIconEqualAndLess: render$1e,
    OmnicaIconEqualAndMore: render$1d,
    OmnicaIconEqualNot: render$1c,
    OmnicaIconError: render$1b,
    OmnicaIconErrorOutlined: render$1a,
    OmnicaIconFieldChange: render$19,
    OmnicaIconFieldValue: render$18,
    OmnicaIconFilesLabeledOutlined: render$17,
    OmnicaIconFilter: render$16,
    OmnicaIconFlag: render$15,
    OmnicaIconFlagOutlined: render$14,
    OmnicaIconFlash: render$13,
    OmnicaIconFolderOutlined: render$12,
    OmnicaIconFormatBullets: render$11,
    OmnicaIconFormula: render$10,
    OmnicaIconGroupAdd: render$$,
    OmnicaIconHelpOutlined: render$_,
    OmnicaIconInfo: render$Z,
    OmnicaIconInfoOutlined: render$Y,
    OmnicaIconLabelBad: render$X,
    OmnicaIconLabelOutlined: render$W,
    OmnicaIconLabelsOutlined: render$V,
    OmnicaIconLabelVip: render$U,
    OmnicaIconLess: render$T,
    OmnicaIconLink: render$S,
    OmnicaIconLoader: render$R,
    OmnicaIconLoading: render$Q,
    OmnicaIconLock: render$P,
    OmnicaIconLockOpenOutlined: render$O,
    OmnicaIconMessageReadOutlined: render$N,
    OmnicaIconMessageUnreadOutlined: render$M,
    OmnicaIconMore: render$L,
    OmnicaIconMoreHorizontal: render$K,
    OmnicaIconNewReleaseOutlined: render$J,
    OmnicaIconNotifications: render$I,
    OmnicaIconOpenInNew: render$H,
    OmnicaIconOpenInNewSquare: render$G,
    OmnicaIconPagesOutlined: render$F,
    OmnicaIconPause: render$E,
    OmnicaIconPinned: render$D,
    OmnicaIconPlay: render$C,
    OmnicaIconPlayCircle: render$B,
    OmnicaIconPlayCircleOutlined: render$A,
    OmnicaIconPodium: render$z,
    OmnicaIconPullRightLeft: render$y,
    OmnicaIconRemove: render$x,
    OmnicaIconReply: render$w,
    OmnicaIconRestore: render$v,
    OmnicaIconRussia: render$u,
    OmnicaIconSavings: render$t,
    OmnicaIconSearch: render$s,
    OmnicaIconSend: render$r,
    OmnicaIconSettingsOutlined: render$q,
    OmnicaIconShopOutlined: render$p,
    OmnicaIconShopping: render$o,
    OmnicaIconShoppingBasket: render$n,
    OmnicaIconShoppingBasketAdd: render$m,
    OmnicaIconSlightlySmiling: render$l,
    OmnicaIconSms: render$k,
    OmnicaIconSmsChatOutlined: render$j,
    OmnicaIconStar: render$i,
    OmnicaIconStop: render$h,
    OmnicaIconTime: render$g,
    OmnicaIconToggleOff: render$f,
    OmnicaIconTools: render$e,
    OmnicaIconUpload: render$d,
    OmnicaIconUser: render$c,
    OmnicaIconUserAdd: render$b,
    OmnicaIconUserOutlined: render$a,
    OmnicaIconUsersSwitch: render$9,
    OmnicaIconVisible: render$8,
    OmnicaIconWalletOutlined: render$7,
    OmnicaIconWarehouse: render$6,
    OmnicaIconWarning: render$5,
    OmnicaIconWebsite: render$4,
    OmnicaIconZoomContext: render$3,
    OmnicaIconZoomIn: render$2,
    OmnicaIconZoomOut: render$1,
};
const camelize = (name) => name.replace(/-./g, x => x[1].toUpperCase());
const capitalize = (name) => name.charAt(0).toUpperCase() + name.slice(1);
const normalize = (name) => 'OmnicaIcon' + capitalize(camelize(name));
const exists = (name) => Object.keys(icons).includes(name);
var script = defineComponent({
    components: Object.assign({}, icons),
    props: {
        /** Название иконки в kebab-case */
        name: {
            type: String,
            validator: (name) => exists(normalize(name)),
            required: true,
        },
    },
    setup(props) {
        const nameComputed = computed(() => {
            const name = normalize(props.name);
            return exists(name) ? name : 'span';
        });
        return {
            nameComputed,
        };
    },
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createBlock(resolveDynamicComponent(_ctx.nameComputed), mergeProps({ class: "omnica-icon" }, _ctx.$attrs), null, 16 /* FULL_PROPS */))
}

script.render = render;
script.__file = "packages/icon/src/UiIcon.vue";

export { script as default };
